/** @jsxImportSource @emotion/react */
import { Trans } from '@lingui/react/macro';
import React from 'react';
import type { DivProps } from 'typings';
import * as S from './styles';

interface IStubTitleProps extends DivProps {}

function StubTitle(props: IStubTitleProps) {
  const { ...rest } = props;

  return (
    <S.MainBlock {...rest}>
      <Trans>Продолжите в мобильном приложении</Trans>
    </S.MainBlock>
  );
}

export default StubTitle;
